var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70828 2H3.45828C2.65414 2 2 2.65414 2 3.45828V7.20828C2 8.01257 2.65414 8.66672 3.45828 8.66672H9.70828C10.5126 8.66672 11.1667 8.01257 11.1667 7.20828V3.45828C11.1667 2.65414 10.5126 2 9.70828 2Z",
    fill: "#ABB5BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70828 10.3333H3.45828C2.65414 10.3333 2 10.9874 2 11.7917V20.5417C2 21.3458 2.65414 22 3.45828 22H9.70828C10.5126 22 11.1667 21.3458 11.1667 20.5417V11.7917C11.1667 10.9874 10.5126 10.3333 9.70828 10.3333Z",
    fill: "#ABB5BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5417 15.3333H14.2917C13.4874 15.3333 12.8333 15.9874 12.8333 16.7917V20.5417C12.8333 21.3458 13.4874 22 14.2917 22H20.5417C21.3459 22 22 21.3458 22 20.5417V16.7917C22 15.9874 21.3459 15.3333 20.5417 15.3333Z",
    fill: "#ABB5BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5417 2H14.2917C13.4874 2 12.8333 2.65414 12.8333 3.45828V12.2083C12.8333 13.0126 13.4874 13.6667 14.2917 13.6667H20.5417C21.3459 13.6667 22 13.0126 22 12.2083V3.45828C22 2.65414 21.3459 2 20.5417 2V2Z",
    fill: "#ABB5BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNormal);
export default __webpack_public_path__ + "static/media/dashboard-normal.e0d6ef84f3feed61b4104cb99b17b3fe.svg";
export { ForwardRef as ReactComponent };